<template>
    <div class="hello">
        {{ msg }} <br>
        {{ a }}<br>
        <button @click="a+=1">点击</button>
    </div>
</template>

<script>
    export default {
        name: 'Test',
        data() {
            return {
                beforeCreate: 'beforeCreate',
                msg: 'Welcome to Your Vue.js App',
                beforeMount: 'beforeMount',
                mounted: 'mounted',
                a: 100,
                timer: null,
            }
        },
        beforeCreate: function () {
            console.log(this.beforeCreate,this.$el);
        },
        created: function () {
            console.log(this.beforeCreate,this.$el);
        },
        beforeMount: function () {
            console.log(this.beforeMount);
        },
        mounted: function () {
            console.log(this.mounted);
            console.log(this.a);
        },
        beforeUpdate: function () {
            console.log(this.a);
        },
        updated: function () {
            console.log(this.a);
        },
        beforeDestroy: function(){
            console.log(this.a);
        },
        destroyed: function(){
            console.log(this.a);
        },

        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>



// WEBPACK FOOTER //
// src/components/Test.vue